"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrespondenceTemplateCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var CorrespondenceTemplateCategory_Factory = /** @class */ (function () {
    function CorrespondenceTemplateCategory_Factory() {
    }
    CorrespondenceTemplateCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RefId: model.RefId,
            UserGenerated: model.UserGenerated,
        };
        return result;
    };
    CorrespondenceTemplateCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RefId: model.RefId,
            UserGenerated: model.UserGenerated,
        };
        return result;
    };
    return CorrespondenceTemplateCategory_Factory;
}());
exports.CorrespondenceTemplateCategory_Factory = CorrespondenceTemplateCategory_Factory;
